import { ThemeAttribute } from '../../../typings/api/models';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

interface ThemeAttributesRequestData {
    grades?: Array<number>;
    showAll?: boolean;
    filter?: object;
    walkStacks?: boolean;
    pageSize?: number;
}

export interface ThemeAttributesResponseData {
    count: number;
    filters: Array<ThemeAttribute>;
    next: number | null;
    previous: number | null;
}

export function getThemeAttributes(
    themeId: number,
    requestData?: ThemeAttributesRequestData
): Promise<ThemeAttributesResponseData> {
    const { apiGetThemeAttributes } = apiConfig.getStaticUrls();
    const { grades, showAll, filter, walkStacks, pageSize } = requestData || {};

    return getFetch(apiGetThemeAttributes, {
        themeId,
        show_all: showAll,
        walk_stacks: walkStacks, // достает атрибуты из стопок в теме
        filters: JSON.stringify(filter),
        grades: grades ? grades.join(',') : undefined,
        page_size: pageSize,
    });
}
